import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/home/home-page.component').then(m => m.HomePageComponent),
        title: 'HBARiot',
    },
    {
        path: 'downloads',
        loadComponent: () => import('./pages/downloads/downloads-page.component').then(m => m.DownloadsPageComponent),
        title: 'HBARiot • Downloads',
    },
    {
        path: 'nodes',
        loadComponent: () => import('./pages/nodes/nodes-page.component').then(m => m.NodesPageComponent),
        title: 'HBARiot • Nodes',
    },
    {
        path: 'requirements',
        loadComponent: () => import('./pages/requirements/requirements-page.component').then(m => m.RequirementsPageComponent),
        title: 'HBARiot • Requirements',
    },
    {
        path: 'docs',
        loadComponent: () => import('./pages/docs/docs-page.component').then(m => m.DocsPageComponent),
        title: 'HBARiot • Docs',
    },
    {
        path: '**',
        redirectTo: '',
    },
];
